import { computed, inject, Injectable, signal } from "@angular/core";
import { PriceSettingEnum } from "@infrastructure/price-setting.enum";
import { UserPreferencesService } from "@services/v2/user-preferences.service";

export interface UserPreferencesState {
	contactCode: string | undefined;
	priceDisplay: PriceSettingEnum | undefined;
	configurationStringActive: boolean | undefined;
	threeDeeActive: boolean | undefined;
}

@Injectable({
	providedIn: 'root'
})
export class UserPreferencesStore {

	userPreferencesService = inject(UserPreferencesService);

	private state = signal<UserPreferencesState>({
		contactCode: undefined,
		priceDisplay: PriceSettingEnum.AllowNone,
		configurationStringActive: false,
		threeDeeActive: true
	});

	contactCode = computed(() => this.state().contactCode);
	priceDisplay = computed(() => this.state().priceDisplay);
	configurationStringActive = computed(() => this.state().configurationStringActive);
	threeDeeActive = computed(() => this.state().threeDeeActive);

	public async setContactCode(contactCode: string) {
		this.state.update(state => ({ ...state, contactCode: contactCode }));

		await this.userPreferencesService.GetUserPreferences(contactCode).then(response => {
			if (response) {
				// console.debug('user preferences response', response);

				this.state.update(state => ({ ...state, priceDisplay: response.Preferences.PriceDisplay, configurationStringActive: response.Preferences.ConfigurationStringActive, threeDeeActive: response.Preferences.ThreeDeeActive }));
			}
		});
	}

	public setPriceDisplay(priceDisplay: PriceSettingEnum) {
		this.state.set({ ...this.state(), priceDisplay: priceDisplay });

		// console.debug('set price display - state ', this.getPrefsAsString());

		this.updateDatabase();
	}

	public toggleConfigurationStringActive() {
		const configurationStateActive = this.state().configurationStringActive;

		this.state.update(state => ({ ...state, configurationStringActive: !configurationStateActive }));

		// console.debug('update configuration string - state ', this.getPrefsAsString());

		this.updateDatabase();
	}

	// toggleThreeDeeActive() {
	// 	const threeDeeActive = this.state().threeDeeActive;

	// 	this.state.update(state => ({ ...state, threeDeeActive: !threeDeeActive }));

	// 	// console.log('toggle 3D active - state ', this.getPrefsAsString());

	// 	this.updateDatabase();
	// }

	private updateDatabase() {
		this.userPreferencesService.PostUserPreferences(this.getPrefsAsString());
	}

	private getPrefsAsString(): any {
		return { ContactCode: this.contactCode(), Preferences: { PriceDisplay: this.priceDisplay(), ConfigurationStringActive: this.configurationStringActive(), ThreeDeeActive: this.threeDeeActive() } };
	}

}